module.exports = __webpack_public_path__ + "static/media/icon-security-shield.917040f4.svg";